import { makeStyles } from '@material-ui/core/styles';
import { theme } from './theme';
import { iconContainer } from './sharedStyles';

export const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '4rem 2rem',
        gap: '1rem',
        fontFamily: theme.fontFamily,
    },
    iconContainer: {
        ...iconContainer,
        width: '40px',
        height: '40px',
    },
    icon: {
        fontSize: theme.fontSizes.xl,
        color: theme.text.dark,
    },
    title: {
        fontWeight: 700,
        fontSize: theme.fontSizes.lg,
        lineHeight: '22px',
        color: theme.text.primary,
        marginBottom: '0.5rem',
    },
    subtitle: {
        fontWeight: 400,
        fontSize: theme.fontSizes.sm,
        lineHeight: '1.5',
        color: theme.text.primary,
        maxWidth: '470px',
    },
})
);